export default {
  baseUrl: process.env.NEXT_PUBLIC_IPSTACK_URL,
  accessKey: process.env.NEXT_PUBLIC_IPSTACK_ACCESS_KEY,
}
